import axios from "axios";
import errorLogger from 'errorLogger'
import config from 'config';

import {
  GET_SESSION,
  SET_SUBSCRIBED,
  SET_SIGNALRCONNECTED,
  SET_SESSION_HELPER
} from "./sessionActionTypes";

const sessionActions = (dispatch) => {
  const fetch = async (id, admin) => {
    try {
      console.log("fetching session");
      let session = await _getSessionFromServer(id, admin);
      dispatch({
        type: GET_SESSION,
        payload: session
      });
    }
    catch (ex) {
      errorLogger.sendLog(JSON.stringify(ex));
      console.log("error", ex);
      //window.location.href = "/?errorMsg=Error, Session maybe closed or operator not ready"
    }
  };

  const setSubscribed = (isSubscribed) => {
    dispatch({
      type: SET_SUBSCRIBED,
      payload: isSubscribed
    });
  }

  const setSignalRConnected = (isClientConnected) => {
    dispatch({
      type: SET_SIGNALRCONNECTED,
      payload: isClientConnected
    });
  }

  const disconnect = async (sessionId) => {
    return new Promise(async (resolve, reject) => {
      await _disconnect(sessionId);
      resolve();
    })
  }

  const setSessionHelper = (sessionHelper) => {
    dispatch({
      type: SET_SESSION_HELPER,
      payload: sessionHelper
    })
  }

  return {
    fetch,
    setSubscribed,
    setSignalRConnected,
    disconnect,
    setSessionHelper
  };
};

const _getSessionFromServer = (id, admin) => {
  return new Promise((resolve, reject) => {
    let url = `${config.url}/api/session/GetCustomer?id=${id}`;
    axios({
      url: url,
      method: "GET"
    }).then((response) => {
      resolve({ id: response.data.sessionId, token: response.data.token });
    }).catch((response) => {
      console.log("Error getting session", response);
      reject();
    });
  });
}

const _disconnect = async (sessionId) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${config.url}/api/Session/Delete?id=${sessionId}`,
      method: "DELETE"
    }).then(() => {
      resolve();
    }).catch((response) => {
      console.log("Error deleting session", response);
      reject();
    });
  });
}

export default sessionActions;